module.exports = __webpack_public_path__ + "static/img/14000014.bd64f4cb.png";